import { render, staticRenderFns } from "./UpdateFuelTankPage.vue?vue&type=template&id=90695d90"
import script from "./UpdateFuelTankPage.vue?vue&type=script&lang=js"
export * from "./UpdateFuelTankPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports